import React from 'react';
import sIcon1 from '../../images/icons/icon_clock.svg'
import sIcon2 from '../../images/icons/icon_dart_board_2.svg'
import sIcon3 from '../../images/icons/icon_target.svg'

const Policy = [
    {
        title: 'Our History',
        subTitle: 'Established in 2013, Kemstec Company Ltd has grown from a local IT solutions provider to a leading technology company in Ghana. Over the past decade, we have successfully delivered innovative solutions to major corporations and government institutions, building a strong reputation for excellence and reliability in the technology sector.',
        icon: sIcon1,
    },
    {
        title: 'Our Mission',
        subTitle: 'To deliver cutting-edge technology solutions that drive business growth and operational excellence. We are committed to providing reliable, innovative, and cost-effective services that meet the evolving needs of our clients while maintaining the highest standards of quality and customer satisfaction.',
        icon: sIcon2,
    },
    {
        title: 'Our Vision',
        subTitle: 'To be the leading provider of integrated technology solutions in West Africa, recognized for innovation, reliability, and exceptional service. We aim to transform businesses through technology, creating sustainable value for our clients and stakeholders.',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section bg-light">
            <div className="container">
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-lg-4" key={pitem}>
                            <div className="iconbox_block">
                                <div className="iconbox_icon">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;